import { render, staticRenderFns } from "./paper-result-ai.vue?vue&type=template&id=1c9773fc&scoped=true"
import script from "./paper-result-ai.vue?vue&type=script&lang=ts"
export * from "./paper-result-ai.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-ai.vue?vue&type=style&index=0&id=1c9773fc&prod&lang=scss&scoped=true"
import style1 from "./paper-result-ai.vue?vue&type=style&index=1&id=1c9773fc&prod&lang=scss&scoped=true"
import style2 from "./paper-result-ai.vue?vue&type=style&index=2&id=1c9773fc&prod&lang=scss"
import style3 from "./paper-result-ai.vue?vue&type=style&index=3&id=1c9773fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9773fc",
  null
  
)

export default component.exports